import { render, staticRenderFns } from "./TimedButton.vue?vue&type=template&id=6cca32b9&scoped=true&"
import script from "./TimedButton.vue?vue&type=script&lang=js&"
export * from "./TimedButton.vue?vue&type=script&lang=js&"
import style0 from "./TimedButton.vue?vue&type=style&index=0&id=6cca32b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca32b9",
  null
  
)

export default component.exports